import { useMediaQuery } from '@dni-react-hooks/use-media-query'
import { parseMediaQuery } from '@pets-ui/utils/parseMediaQuery'

export type WpCartMobileMediaQuery = '@media (max-width: 983px)'
const MOBILE: WpCartMobileMediaQuery = '@media (max-width: 983px)'

export const conditions = {
  mobile: parseMediaQuery(MOBILE),
}

export const useWpCartResponsive = (condition: keyof typeof conditions) => {
  return useMediaQuery(conditions[condition])
}
